export default __webpack_public_path__ + "static/MonikaHalan-3f2786e5ec9a33cac1487e27d2eec283.png";